import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'clsx'
import SVG from 'react-inlinesvg'
import _size from 'lodash/size'
// Redux
import { setViewType } from '~lib/saga/filter/actions'
// Context
import { allCategories } from '~context/GlobalContext'
// Components
import { SortByItem } from '~components/SortBy'
import { ListIcon, GridIcon } from '~components/Icons'
// Styles
import useStyles from './ContainerHeader.style'

const filterSelector = (state) => state.filter

const ContainerHeader = () => {
  const dispatch = useDispatch()
  const {
    data: {
      id: filterId,
      isFiltered,
      title: filterTitle,
      size: filterSize,
      sort: filterSort,
      viewType: filterViewType,
      year: filterYear,
    },
    default: { year: yearDefault },
    error: filterError, // eslint-disable-line no-unused-vars
    status: filterStatus, // eslint-disable-line no-unused-vars
  } = useSelector(filterSelector)

  const classes = useStyles({
    categoryId: filterId,
    categoryTitle: filterTitle,
  })

  const handleViewType = (type) => dispatch(setViewType(type))

  return (
    <div
      className={cx(
        classes.gridHeader,
        isFiltered && classes.gridHeaderFilter,
        'rank' !== filterSort && classes.gridHeaderSort,
        yearDefault !== filterYear && classes.gridHeaderYear
      )}
    >
      <div className={cx(classes.buttonGroup)}>
        <button
          className={cx(
            classes.button,
            classes.buttonGrid,
            'card' === filterViewType && classes.selected,
            'card' === filterViewType && classes.buttonGridSelected
          )}
          onClick={() => handleViewType('card')}
          type="button"
        >
          <span>Grid</span>
          <SVG
            src={GridIcon}
            width={12}
            height={12}
            title="Switch to Grid View"
            description="A square icon with masonry grid layout"
          />
        </button>
        <button
          className={cx(
            classes.button,
            classes.buttonList,
            'list' === filterViewType && classes.selected,
            'list' === filterViewType && classes.buttonListSelected
          )}
          onClick={() => handleViewType('list')}
          type="button"
        >
          <SVG
            src={ListIcon}
            width={12}
            height={10}
            title="Switch to List View"
            description="A square icon horizontally ordered bars in 3 rows"
          />
          <span>List</span>
        </button>
      </div>
      {yearDefault !== filterYear && (
        <>
          {0 < filterSize && (
            <h3
              className={cx(classes.title, classes.yearTitle)}
              data-text={filterYear}
            >
              {filterYear}
            </h3>
          )}
        </>
      )}
      {!isFiltered && yearDefault === filterYear && (
        <p className={cx(classes.leadText)}>
          The ultimate ranking of fandoms — from sports to entertainment,
          celebrities to gaming. <strong>The FanSided 250</strong>.
        </p>
      )}
      {1 === filterSize && (
        <h1 className={cx(classes.title)} data-text={filterTitle}>
          {filterTitle}
        </h1>
      )}
      <div className={cx(classes.sortFilterContainer)}>
        {allCategories !== filterId &&
          _size(allCategories) !== _size(filterId) && (
            <SortByItem filter={true} sortFilter={filterTitle} />
          )}
        {'rank' !== filterSort && (
          <SortByItem filter={false} sortFilter={filterSort} />
        )}
      </div>
    </div>
  )
}

export default ContainerHeader
